import { COMPUTED_WHATSAPP_VARIABLE_KEYS, type ComputedWhatsAppVariableKey } from 'cpool-constants';

export const COMPUTED_VARIABLE_PREVIEW_EXAMPLES: Record<ComputedWhatsAppVariableKey, string> = {
    [COMPUTED_WHATSAPP_VARIABLE_KEYS.DOKUMENT_UPLOAD_LINK]: 'https://dokumente.kredit.de/?pl=ABC123',
    [COMPUTED_WHATSAPP_VARIABLE_KEYS.TRUSTPILOT_LINK]: 'https://de.trustpilot.com/evaluate-bgl/kredit.de?p=ABC123',
};

export const isComputedVariablePreviewKey = (name: string): name is ComputedWhatsAppVariableKey =>
    name in COMPUTED_VARIABLE_PREVIEW_EXAMPLES;
